var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"app_main"},[_c('router-view',{attrs:{"name":"main"}}),_c('router-view',{attrs:{"name":"slidebar"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }